import {
  ApolloClient,
  InMemoryCache,
  createQueryPreloader,
} from '@apollo/client';
import type {
  OperationVariables,
  PreloadQueryFetchPolicy,
  TypedDocumentNode,
} from '@apollo/client';
import type { Params } from 'react-router';

import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { IS_TEST_RUNNER } from '@sorare/core/src/config';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import { GRAPHQL_ENDPOINT } from 'constants/config';

export const client = new ApolloClient({
  uri: GRAPHQL_ENDPOINT,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          posts: {
            keyArgs: ['where'],
            merge(existing = { nodes: [] }, incoming = { nodes: [] }) {
              return {
                ...incoming,
                nodes: [...existing.nodes, ...(incoming.nodes || [])],
              };
            },
          },
        },
      },
    },
  }),
  devtools: {
    enabled: !IS_TEST_RUNNER,
  },
});

const blogPreloadQuery = createQueryPreloader(client);

export const blogQueryLoader = <
  TParams extends Params,
  TData = any,
  TVariables extends OperationVariables = any,
>(
  query: TypedDocumentNode<TData, TVariables>,
  getVariables?: (
    options: TParams & {
      sport: Sport;
      searchParams: URLSearchParams;
      pathname: string;
    }
  ) => TVariables,
  loaderOptions?: {
    fetchPolicy?: PreloadQueryFetchPolicy;
    preventTransitionBeforeLoaded?: boolean;
  }
) => {
  return queryLoader(query, getVariables, {
    ...loaderOptions,
    preloadQuery: { current: blogPreloadQuery },
  });
};
